import React, { ReactNode } from "react";
import styled from "styled-components";
import { H4, Text, fontFamilies } from "@commonsku/styles";
import { IconCircle } from "../../helpers/IconCircle";

type Props = {
  icon: ReactNode;
  heading: ReactNode;
  description: ReactNode;
  iconBackgroundColor?: string;
  iconBorderColor?: string;
  children?: ReactNode;
};

const Screen = styled.div`
  text-align: center;
  padding: 48px 16px;
  max-width: 520px;
  margin: 0 auto;
`;

const CenteredIconCircle = styled(IconCircle)`
  margin: 0 auto;
`;

const Heading = styled(H4)`
  margin: 16px 0 8px;
`;

const Description = styled(Text)`
  display: block;
  margin: 0 0 24px;
  font-family: ${fontFamilies.regular};
`;

export function ForwardScreen({ icon, heading, description, iconBackgroundColor, iconBorderColor, children }: Props) {
  return (
    <Screen>
      <CenteredIconCircle $backgroundColor={iconBackgroundColor} $borderColor={iconBorderColor}>{icon}</CenteredIconCircle>
      <Heading>{heading}</Heading>
      <Description>{description}</Description>
      {children}
    </Screen>
  );
}
